import '../core/polyfils';

// @ts-ignore
import Glide, {Autoplay, Breakpoints, Controls} from '@glidejs/glide/dist/glide.modular.esm'

declare var sliderParams: {
    id: string;
};

class StaSlider {

    br = {
        480: {
            perView: 1
        },
        600: {
            perView: 2
        },
        960: {
            perView: 3
        }
    }

    container: HTMLElement;
    slider: HTMLElement;
    slidesList: HTMLElement;
    params: {
        category: string;
        per_page: string;
        title: string;
    }

    constructor() {
        this.slider = document.getElementById(sliderParams.id);
        this.init();
        this.initActions();
    }

    init() {
        if (this.slider) {
            let slideNum = Array.from(this.slider.getElementsByClassName('glide__slide')).length;
            let type = 'carousel';

            if (slideNum < 3) {
                type = 'slider';
                (document.getElementsByClassName('glide__arrows')[0] as HTMLElement).style.display = 'none'
            }

            new Glide(this.slider,
                {
                    type: type,
                    startAt: 0,
                    perView: 3,
                    autoplay: '8000',
                    hoverpause: true,
                    breakpoints: this.br,
                }
            ).mount({Controls, Breakpoints, Autoplay});
        }
    }

    initActions() {
        Array.from(this.slider.getElementsByClassName('open-preview')).forEach((el: HTMLElement) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                window.location.href = el.dataset.href;
            })
        })
    }
}

new StaSlider();
